import React from 'react';

const YellowAirplaneMobile = () => {
    return (
        <svg
            width="64"
            height="40"
            viewBox="0 0 64 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="64" height="40" rx="20" fill="#FFC24C" />
            <path
                d="M38.1645 20.2917C38.2703 20.2329 38.3359 20.1214 38.3359 20.0003C38.3359 19.8793 38.2703 19.7677 38.1645 19.7089L36.6429 18.8636C33.6452 17.1983 30.4852 15.8436 27.2121 14.8207L26.7687 14.6822C26.6675 14.6505 26.5573 14.669 26.4718 14.7318C26.3864 14.7946 26.3359 14.8943 26.3359 15.0003V18.8337C26.3359 19.0109 26.4747 19.1572 26.6518 19.1665L27.3248 19.202C28.9659 19.2883 30.597 19.5109 32.2012 19.8674L32.3601 19.9027C32.3954 19.9106 32.4107 19.925 32.4192 19.9365C32.43 19.951 32.4384 19.9733 32.4384 20.0003C32.4384 20.0274 32.43 20.0497 32.4192 20.0642C32.4107 20.0756 32.3954 20.0901 32.3601 20.0979L32.2012 20.1332C30.597 20.4897 28.9659 20.7123 27.3248 20.7987L26.6518 20.8341C26.4747 20.8434 26.3359 20.9897 26.3359 21.167V25.0003C26.3359 25.1064 26.3864 25.2061 26.4718 25.2689C26.5573 25.3317 26.6675 25.3501 26.7687 25.3185L27.2121 25.1799C30.4852 24.1571 33.6452 22.8024 36.6429 21.137L38.1645 20.2917Z"
                fill="#222522"
            />
        </svg>
    );
};

export default YellowAirplaneMobile;
